var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed } from 'mobx';
import { generateConfigurations } from '../../../cli/src/config-generator';
var ConfiguratorStore = /** @class */ (function () {
    function ConfiguratorStore(initialState) {
        this.useJs = false;
        this.useTs = false;
        this.useScss = false;
        this.useCss = false;
        this.useFonts = false;
        this.useImages = false;
        this.useHtml = false;
        this.useClean = false;
        this.useDevServer = false;
        this.useCli = false;
        Object.assign(this, initialState);
    }
    Object.defineProperty(ConfiguratorStore.prototype, "generatedUserConfigurations", {
        get: function () {
            return generateConfigurations(this);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useJs", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useTs", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useScss", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useCss", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useFonts", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useImages", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useHtml", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useClean", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useDevServer", void 0);
    __decorate([
        observable
    ], ConfiguratorStore.prototype, "useCli", void 0);
    __decorate([
        computed
    ], ConfiguratorStore.prototype, "generatedUserConfigurations", null);
    return ConfiguratorStore;
}());
export { ConfiguratorStore };
